module.exports = __webpack_public_path__ + "app/layouts/confirm-tQ69XRDQ.html";